import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { EmotionIconBase } from '@emotion-icons/emotion-icon';
export var VxModelsLogo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(EmotionIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.805 14.32l2.111 3.054H17.1l-.702-1.017-1.142 1.653.858 1.24H23.5l-4.555-6.583-1.14 1.653zm-5.808-4.324L9.989 7.092H7.705l4.292 6.21 5.595-8.09 2.817-.002-8.412 12.164-8.409-12.16 7.918-.003 1.2 1.735 1.142-1.653-1.357-1.965H0l11.997 17.349L24 3.327h-7.395l-4.608 6.669z"
  }));
});
VxModelsLogo.displayName = 'VxModelsLogo';
export var VxModelsLogoDimensions = {
  height: 24,
  width: 24
};